import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import useLoginContainer from "../containers/useLoginContainer";
import { useContent } from "../content/useContent";
import { useAlert } from "../context/AlertContext";
import { Routes } from "../routes/Routes";

const useCallApi = () => {
  const { msg, setErrorMessage, error } = useAlert();
  const navigate = useNavigate();
  const { generalErrors } = useContent();
  const { handleLogout } = useLoginContainer();
  const [loading, setLoading] = useState<boolean>(false);

  const callApi = useCallback(async (API: any, onSuccess: any, onError?: any) => {
    setLoading(true);
    try {
      const data = await API;
      onSuccess(data);
    } catch (error: any) {
      console.log({ error });
      if (onError) {
        onError();
      }

      if (error?.response?.status === 401) {
        setTimeout(() => setErrorMessage(generalErrors.tokenExpired), 1000);
        handleLogout();
        navigate(Routes.login);
      } else if (error?.response?.data?.errorDescription) {
        setErrorMessage(error.response.data.errorDescription);
      } else if (error?.response?.data?.errorMessage) {
        setErrorMessage(error.response.data.errorMessage);
      } else {
        setErrorMessage(generalErrors.wentWrong);
      }
    } finally {
      setLoading(false);
    }
  }, [generalErrors.tokenExpired, generalErrors.wentWrong, navigate, setErrorMessage, handleLogout]);

  return { callApi, loading, msg, error };
};

export default useCallApi;
